import { useEffect } from 'react';

import { isInPopUpBrowser } from '@skippay/core/modules/clientInfo';

function useInAppBrowserClose() {
	useEffect(() => {
		if (isInPopUpBrowser()) {
			window.redirectPopupBrowser = true;
		}
	}, []);
}

export default useInAppBrowserClose;
